export { default as NoAnswer, ReactComponent as NoAnswerComponent } from './NoAnswer.svg';
